import React, { Component } from "react";
import Styles from "./styles";
import Card from "../Card";

export const withErrorBoundary = WrappedComponent =>
  class extends Component {
    constructor(props) {
      super(props);
      this.state = { error: null, errorInfo: null };
    }

    componentDidCatch = (error, errorInfo) => catchFunc(error, errorInfo, this);

    render() {
      if (this.state.errorInfo) {
        return handleError(this);
      }
      // Normally, just render children
      return <WrappedComponent {...this.props} />;
    }
  };

const catchFunc = (error, errorInfo, ctx) => {
  // catch errors in any components below and re-render with error message
  ctx.setState({
    error: error,
    errorInfo: errorInfo
  });
  // log error messages, etc.
};

const handleError = ctx => (
  <Card title="Something went wrong">
    <div style={ctx.props.style || Styles.error}>
      {process.env.NODE_ENV == "development" ? (
        <details style={{ whiteSpace: "pre-wrap" }}>
          {ctx.state.error && ctx.state.error.toString()}
          <br />
          {ctx.state.errorInfo.componentStack}
        </details>
      ) : (
        <div>
          This error has been logged, if this error persists please reach out to
          your rep.
        </div>
      )}
    </div>
  </Card>
);
